export const isUpperCase = (str: string) =>
  str !== str.toLowerCase() && str === str.toUpperCase();

export const JSON_DATE_PARSER = (key: any, value: string | number | Date) => {
  const reISO = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*))(?:Z|(\+|-)([\d|:]*))?$/;
  if (typeof value === 'string') {
    const a = reISO.exec(value);
    if (a) {
      return new Date(value);
    }
  }
  return value;
};

export const getAvatarInitials = (name: string) => {
  if (!name) {
    return '';
  }
  if (name.length < 4) {
    return name.toUpperCase();
  }
  let lastChar = '';
  let beforeLastChar = '';
  for (let i = 1; i < name.length; i++) {
    if (
      lastChar !== '' &&
      (lastChar === '-' ||
        (isUpperCase(lastChar) && !isUpperCase(beforeLastChar)))
    ) {
      return (
        name[0] + (lastChar === '-' ? name.charAt(i) : lastChar)
      ).toUpperCase();
    }
    beforeLastChar = lastChar;
    lastChar = name.charAt(i);
  }
  return name.charAt(0).toUpperCase();
};
